// Card.jsx
import React from 'react';

function Card({ titoloCard, children }) {    
    return (
        <div className="card">
            <div className="card-header">
				<h6 className="hstack gap-2 mb-0">
					{titoloCard}
                </h6>
			</div>
           <div className="card-body pb-0">
                 {children}
            </div>
        </div>
    );
}

export default Card;
